export { default as LoadingPrimaryMenuSkeleton } from './LoadingPrimaryMenuSkeleton';
